/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Modal', ['ui.bootstrap', 'access.FlashMessages', 'access.Utils'])
    .config(['$provide', 'ENV', function ($provide, ENV) {
        $provide.decorator('$modal', ['$delegate', '$modalStack', function ($modal, $modalStack) {
            var
                openFn = $modal.open,
                stackOpenFn = $modalStack.open;

            $modal.open = function () {
                var
                    args = arguments[0],
                    attrs = args['domOptions'] || {},
                    modalInstance,
                    modalTemplatesPath = 'modals/',
                    bodyTemplate = ENV['templatesPath'] + (attrs['modalBodyTemplate'] ? attrs['modalBodyTemplate'] : modalTemplatesPath + 'actions/' + attrs['modalAction']) + '.html',
                    footerTemplate = ENV['templatesPath'] + (attrs['modalFooterTemplate'] ? attrs['modalFooterTemplate'] : modalTemplatesPath + 'footer') + '.html';


                args['templateUrl'] = ENV['templatesPath'] + (args['templateUrl'] ? args['templateUrl'] : modalTemplatesPath + 'modal') + '.html';

                modalInstance = openFn.apply(null, [args]);
                modalInstance.options = {
                    type: attrs['modalType'] || 'confirm',
                    title: attrs['modalTitle'],
                    subTitle: attrs['modalSubTitle'] || null,
                    bodyTemplate: bodyTemplate,
                    bodyText: attrs['modalBodyText'],
                    footerTemplate: footerTemplate,
                    action: attrs['modalAction'],
                    actionButton: attrs['modalActionButton'],
                    cancelButton: attrs['modalCancelButton'],
                    notifications: attrs['modalNotifications'],
                    onEnter: attrs['modalOnEnter']
                };

                return modalInstance;
            };

            $modalStack.open = function (modalInstance, options) {
                return stackOpenFn.apply(null, [modalInstance, options])
                    .then(function () {
                        modalDom = $modalStack.getTop().value.modalDomEl;

                        modalDom.addClass('loaded');
                    });
            };

            return $modal;
        }]);

    }]);
